const hexToRgb = (hex) => {
    const hexArray = hex.substring(1).split('');
    const rgbPrefix = '0x';
    const largerHex = hexArray.length === 6;

    return hexArray
        .reduce(
            (rgb, hex, index) => {
                const nextHexIndex = index + 1;
                if (largerHex && nextHexIndex % 2 === 0) return rgb;
                return [
                    ...rgb,
                    Number(`${rgbPrefix}${hex}${largerHex ? hexArray[nextHexIndex] : hex}`)
                ]
            }
        , []);
}

export {
    hexToRgb
}